import { useEffect } from 'react';
import { AGENCY_ID  } from "../../../config/appConfig";

interface JQueryBsMultiSelect extends JQuery<HTMLElement> {
    bsMultiSelect(options: any): any;
}

export const WidgetNetwork = () => {
    useEffect(() => {
        // Funzione per caricare dinamicamente uno script JS
        const loadScript = (url: string) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = url;
                script.async = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        };

        // Funzione per caricare dinamicamente un file CSS
        const loadCss = (url: string) => {
            return new Promise((resolve, reject) => {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = url;
                link.onload = resolve;
                link.onerror = reject;
                document.head.appendChild(link);
            });
        };

        const initializeWidget = async () => {
            try {
                // Carica i file CSS e JS necessari
                await loadCss("https://network.casagest24.it/widget/js/multiselect/BsMultiSelect.min.css");
                if (!(window as any).jQuery) {
                    await loadScript("https://network.casagest24.it/widget/js/jquery-3.6.0.min.js");
                }
                await loadScript("https://network.casagest24.it/widget/js/popper.min.js");
                await loadScript("https://network.casagest24.it/widget/js/multiselect/BsMultiSelect.min.js");
                await loadScript("https://network.casagest24.it/widget/widget.js");

                const _id = AGENCY_ID;
                const _orientation = 0;

                // Carica il markup del widget da widget.php
                $("#network").load("https://network.casagest24.it/widget/widget.php", function () {
                    // Imposta il valore nascosto per agenzia e altre impostazioni
                    $("#widget_network #agenzia_id").val(_id);
                    if (typeof _orientation !== "undefined" && _orientation) {
                        $("#widget_network").addClass("horizontal");
                    }

                    // Carica le opzioni per il select "contratto"
                    $.ajax({
                        url: "https://network.casagest24.it/widget/php/get_contratti.php",
                        type: "GET",
                        dataType: "json",
                        success: function (data) {
                            const $contratto = $("#contratto");
                            $contratto.empty();
                            $.each(data, function (_index, item) {
                                $contratto.append(
                                    $("<option></option>")
                                        .attr("value", item.Value)
                                        .text(item.Text)
                                );
                            });
                        },
                        error: function (_jqXHR, textStatus, errorThrown) {
                            console.error("Errore nel caricamento dei contratti:", textStatus, errorThrown);
                        }
                    });

                    // Carica le opzioni per il select "categoria"
                    $.ajax({
                        url: "https://network.casagest24.it/widget/php/get_categorie.php",
                        type: "GET",
                        dataType: "json",
                        success: function (data) {
                            const $categoria = $("#categoria");
                            $categoria.empty();
                            $.each(data, function (_index, item) {
                                $categoria.append(
                                    $("<option></option>")
                                        .attr("value", item.Value)
                                        .text(item.Text)
                                );
                            });
                            // (Opzionale) Pre-seleziona una categoria e attiva il trigger "change"
                            // $categoria.val("1").trigger("change");
                        },
                        error: function (_jqXHR, textStatus, errorThrown) {
                            console.error("Errore nel caricamento delle categorie:", textStatus, errorThrown);
                        }
                    });

                    // Inizializza il multi-select per "tipologia"
                    const $tipologia = $("#tipologia") as JQueryBsMultiSelect;
                    // Rimuovo lo style inline "display: none" se presente
                    $tipologia.removeAttr("style");
                    $tipologia.bsMultiSelect({ placeholder: "Tipologie" });

                    // Gestisci il cambio di valore in "categoria" per caricare le tipologie
                    $("#categoria").on("change", function () {
                        const selectedVal = $(this).val();
                        if (selectedVal) {
                            const url = "https://network.casagest24.it/widget/php/get_tipologie.php?val=" + selectedVal;
                            $.ajax({
                                url: url,
                                type: "GET",
                                dataType: "json",
                                success: function (data) {
                                    // Se il plugin è già inizializzato, lo distruggiamo
                                    if ($tipologia.data("bsMultiSelect")) {
                                        $tipologia.bsMultiSelect("destroy");
                                    }
                                    // Rimuovo lo style che nasconde l'elemento (se presente)
                                    $tipologia.removeAttr("style");
                                    // Svuoto e ripopolare il select "tipologia" con i nuovi dati
                                    $tipologia.empty();
                                    $.each(data, function (_index, item) {
                                        $tipologia.append(
                                            $("<option></option>")
                                                .attr("value", item.Value)
                                                .text(item.Text)
                                        );
                                    });
                                    // Ri-inizializzo il multiselect
                                    $tipologia.bsMultiSelect({
                                        // placeholder: "Tipologie" // Opzionale, per mostrare un placeholder
                                    });
                                    // (Opzionale) Attendo un breve ritardo per essere sicuri che il DOM sia aggiornato
                                    setTimeout(() => {
                                        $tipologia.bsMultiSelect({ placeholder: "Tipologie" });
                                    }, 50);
                                },
                                error: function (_jqXHR, textStatus, errorThrown) {
                                    console.error("Errore nel caricamento delle tipologie:", textStatus, errorThrown);
                                }
                            });
                        }
                    });

                    // Opzionale: se vuoi caricare subito le tipologie in base alla categoria già selezionata
                    $("#categoria").trigger("change");
                });
            } catch (error) {
                console.error("Error loading the widget scripts", error);
            }
        };

        initializeWidget();

        return () => {
            // Cleanup se necessario: rimuovere script dinamici o gestire listener
        };
    }, []);

    return (
        <div>
            <div id="network"></div>
        </div>
    );
};

export default WidgetNetwork;
